import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "c-autocomplete" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_joy_input = _resolveComponent("joy-input")!
  const _component_joy_form_error = _resolveComponent("joy-form-error")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_joy_input, {
      id: _ctx.id,
      ref: "location",
      disabled: _ctx.disabled,
      required: _ctx.required,
      invalid: _ctx.error,
      value: _ctx.formattedAddress,
      placeholder: _ctx.$msg('generic.city.label'),
      "aria-placeholder": _ctx.$msg('generic.city.label'),
      name: _ctx.name,
      type: "text",
      autocomplete: "address-level4"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.label), 1)
      ]),
      _: 1
    }, 8, ["id", "disabled", "required", "invalid", "value", "placeholder", "aria-placeholder", "name"]),
    (_ctx.error & _ctx.msgError)
      ? (_openBlock(), _createBlock(_component_joy_form_error, {
          key: 0,
          "no-html-error-text": _ctx.$msg('form.field.error.message.required.generic')
        }, null, 8, ["no-html-error-text"]))
      : _createCommentVNode("", true)
  ]))
}